import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { State } from "../../common/selectOption/selectOption";
import { useAddCustomerMutation, useUpdateCustomerMutation } from "../../redux/api/userApi";
import * as Yup from "yup";
import { useFormik } from "formik";
const customerSchema = Yup.object().shape({
  customerName: Yup.string().required('Customer Name is required'),
  phone: Yup.string()
  .required('Phone Number is required')
  .matches(
    /^[6-9]\d{9}$/,
    'Phone Number must be a valid 10-digit Indian mobile number'
  ),
  email: Yup.string()
    .email('Invalid email address'),
  city: Yup.string(),
  state: Yup.string(),
  address: Yup.string(),
  postalCode: Yup.string(),
  creditLimit: Yup.number()
    .typeError('Credit Limit must be a number'),
  status: Yup.boolean().default(true)
});
const CustomerModal = ({ isEdit = false, customerData = null,  onSuccess = () => {} }) => {
  const [addCustomer] = useAddCustomerMutation();
  const [updateCustomer] = useUpdateCustomerMutation();
  const [isReady, setIsReady] = useState(false);
  console.log("isedit", customerData); 
  const formik = useFormik({
    initialValues: {
      customerName: '',
      email: '',
      creditLimit: 0,
      phone: '',
      address: '',
      city: '',
      state: '',
      postalCode: '',
      status: true
    },
    validationSchema: customerSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        if (isEdit && customerData) {
          await updateCustomer({ id: customerData._id, ...values }).unwrap();
        } else {
          await addCustomer(values).unwrap();
        }
        onSuccess();
        resetForm();
        document.getElementById('add-customer').classList.remove('show');
        document.querySelector('.modal-backdrop')?.remove();
      } catch (error) {
        console.error('Error submitting customer:', error);
      } finally {
        setSubmitting(false);
      }
    }
  });

 

  useEffect(() => {
    // Only initialize when we have stable props
    if (isEdit) {
      if (customerData) {
        console.log("Initializing form with:", customerData);
        formik.setValues({
          customerName: customerData.customerName || '',
          email: customerData.email || '',
          creditLimit: customerData.creditLimit || 0,
          phone: customerData.phone || '',
          address: customerData.address || '',
          city: customerData.city || '',
          state: customerData.state || '',
          postalCode: customerData.postalCode || '',
          status: customerData.status !== undefined ? customerData.status : true
        });
        setIsReady(true);
      }
    } else {
      formik.resetForm();
      setIsReady(true);
    }
  }, [isEdit, customerData?._id]); 

  const handleStatusChange = (e) => {
    formik.setFieldValue('status', e.target.checked);
  };
  console.log("  value={formik.values.customerName}", formik.values.customerName);
  return (
    <div>
      <>
        {/* Add Customer */}
        <div className="modal fade" id="add-customer">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="page-title">
                <h4>{isEdit ? 'Edit Customer' : 'Add Customer'}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    formik.resetForm();
                    // setIsInitialized(false);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Customer Name <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="text" 
                        className={`form-control ${formik?.touched?.customerName && formik?.errors?.customerName ? 'is-invalid' : ''}`}
                        name="customerName"
                        value={formik?.values?.customerName}
                        onChange={formik?.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.customerName && formik.errors.customerName && (
                        <div className="invalid-feedback">{formik.errors.customerName}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Email <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="email" 
                        className={`form-control ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="invalid-feedback">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Credit Limit <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="number" 
                        className={`form-control ${formik.touched.creditLimit && formik.errors.creditLimit ? 'is-invalid' : ''}`}
                        name="creditLimit"
                        value={formik.values.creditLimit}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.creditLimit && formik.errors.creditLimit && (
                        <div className="invalid-feedback">{formik.errors.creditLimit}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="text" 
                        className={`form-control ${formik.touched.phone && formik.errors.phone ? 'is-invalid' : ''}`}
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phone && formik.errors.phone && (
                        <div className="invalid-feedback">{formik.errors.phone}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Address <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="text" 
                        className={`form-control ${formik.touched.address && formik.errors.address ? 'is-invalid' : ''}`}
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.address && formik.errors.address && (
                        <div className="invalid-feedback">{formik.errors.address}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">City</label>
                      <input 
                        type="text" 
                        className="form-control"
                        name="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">State</label>
                      <Select
                        options={State}
                        classNamePrefix="select"
                        name="state"
                        value={State.find(option => option.value === formik.values.state)}
                        onChange={(option) => formik.setFieldValue('state', option.value)}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Postal Code</label>
                      <input 
                        type="text" 
                        className="form-control"
                        name="postalCode"
                        value={formik.values.postalCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-0">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <input
                          type="checkbox"
                          id="customer-status"
                          className="check"
                          checked={formik.values.status}
                          onChange={handleStatusChange}
                        />
                        <label htmlFor="customer-status" className="checktoggle mb-0" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    formik.resetForm();
                    // setIsInitialized(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? 'Processing...' : isEdit ? 'Update Customer' : 'Add Customer'}
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
        {/* /Add Customer */}
   
      </>

    </div>
  );
};

export default CustomerModal;
